module.exports = __webpack_public_path__ + "img/icon-flag-ho.b3a52436.svg";